import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import { Text } from 'common';

import { BlockKeyValuesField } from '../../../ConfigFields/KeyValues/KeyValuesField';

export function InformationExtractionExtractionFieldsFormField() {
  return (
    <Accordion variant="elevation">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Text variant="heading5">Extraction fields</Text>
      </AccordionSummary>
      <AccordionDetails>
        <BlockKeyValuesField
          fieldName="config.extractionFields"
          label="Tell the model what to extract"
          addRowHelperText="field"
          keyValueFieldNames={{
            key: {
              name: 'name',
              label: 'Name',
            },
            value: {
              name: 'description',
              label: 'Description',
            },
          }}
          required
          getDefaultNewRow={() => ({
            id: crypto.randomUUID(),
            name: '',
            description: '',
          })}
        />
      </AccordionDetails>
    </Accordion>
  );
}
